import {
	Anchor,
	Box,
	createStyles,
	Group,
	Stack,
	useMantineTheme,
} from '@mantine/core';
import { getFileExtensionConfig } from '@repo/common/utils/fileExtensionConfig';
import { Icon, IconButton, Text } from '@repo/foundations';

const useStyles = createStyles((theme) => ({
	wrapper: {
		background: theme.other.getColor('surface/tertiary/default'),
		borderRadius: theme.radius.md,
		width: 250,
		gap: theme.spacing.sm,
		padding: `${theme.spacing.xs} ${theme.spacing.sm}`,

		'&:first-of-type': {
			marginLeft: theme.spacing.xs,
		},
		'&:last-of-type': {
			marginRight: theme.spacing.xs,
		},
	},
	textWidth: {
		// explicitly set width to allow for text truncation
		// 100% - extension icon width - delete button width - Group gap - Group gap
		width: `calc(100% - 28px - 28px - ${theme.spacing.sm} - ${theme.spacing.sm})`,
		textDecoration: 'none',
		color: 'inherit',

		'&:hover': {
			textDecoration: 'none',
			cursor: 'pointer',
		},
	},
	icon: {
		borderRadius: theme.radius.sm,
	},
}));

interface AttachmentProps {
	title: string;
	href: string;
	onRemove: () => void;
}

export function Attachment({ title, href, onRemove }: AttachmentProps) {
	const { classes } = useStyles();
	const theme = useMantineTheme();

	const parts = title.split('.');
	const extension = parts.length > 1 ? parts.pop() : '';
	const extensionConfig = getFileExtensionConfig(extension ?? '');

	return (
		<Group className={classes.wrapper} position="apart" noWrap>
			<Box
				p="3xs"
				className={classes.icon}
				style={{ background: theme.other.getColor(extensionConfig.color) }}
			>
				<Icon color={extensionConfig.text} name={extensionConfig.icon} />
			</Box>
			<Anchor href={href} target="_blank" className={classes.textWidth}>
				<Stack spacing={0}>
					<Text weight="bold" size="sm" truncate>
						{title}
					</Text>
					<Text transform="uppercase" color="text/secondary/default" size="xs">
						{extension}
					</Text>
				</Stack>
			</Anchor>
			<IconButton variant="tertiary" onClick={onRemove} iconName="x" />
		</Group>
	);
}
